import React, { useEffect } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { useDocTitle } from '../components/CustomHook';
import Cal from '@calcom/embed-react';

const Launch = () => {
  useDocTitle('Launch Your Project');
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <NavBar />
      <div className="pt-24 pb-16 px-4">
        <div className="max-w-4xl mx-auto bg-white border border-gray-200 rounded-lg shadow p-8">
          <h1 className="text-3xl font-bold text-blue-900 mb-4">Launch Your Project</h1>
          <p className="text-gray-700 mb-4">Our onboarding is straightforward. Share your repo and stack, we set up the environment, and you ship. <Link to='/process' className='text-blue-900 underline'>See the full process</Link> for more details.</p>
          <ol className="list-decimal list-inside text-gray-700 mb-6 space-y-1">
            <li>Talk to us about your code and goals.</li>
            <li>We configure builds and infrastructure for you.</li>
            <li>Deploy with monitoring and ongoing support.</li>
          </ol>
          <div className="my-8">
            <Cal calLink='artisan-hosting/discovery-call' style={{ width: '100%', height: '650px' }}></Cal>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Launch;
